<template>
  <b-form @submit.prevent="setDraft" class="form">
    <h5>Operación</h5>

    <b-row class="form-group" v-if="user.role.code === constants.EJECUTIVO_CUENTA">
      <label class="col-sm-2 col-form-label">Cliente</label>
      <div class="col-sm-5">
        <v-select
          v-model="company"
          :value="company.id"
          :options="companies"
          label="name"
          :on-change="setCompany"
          :clearable="false"
          :disabled=disableClient
        ></v-select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label" for>Servicio</label>
      <div class="col-sm-5">
        <select
          v-model="service.service_type_id"
          required
          class="form-control"
          v-on:change="selectServiceType()"
        >
          <option
            v-for="(service_type,k) in service_types"
            :key="k"
            :value="service_type.id"
          >{{service_type.name}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Referencia</label>
      <div class="col-sm-5">
        <input type="text" v-model="service.reference" class="form-control">
        <small class="form-text text-muted">Para facturación</small>
      </div>
    </b-row>

    <b-row class="form-group" v-if="charge_type && charge_type.name !== constants.SUELTA">
      <label class="col-sm-2 col-form-label">Línea naviera</label>
      <div class="col-sm-5">
        <v-select
          v-model="shipping_line"
          :value="service.shipping_line_id"
          :options="shipping_lines"
          label="name"
          :on-change="setShippingLine"
        ></v-select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">
        {{service_type.code === constants.IMPORTACION ? 'Número BL' : 'Número Booking'}}</label>
      <div class="col-sm-5">
        <input type="text" class="form-control" v-model="service.doc_number">
      </div>
    </b-row>

    <!-- <b-row class="form-group" v-if="service_type.code === constants.EXPORTACION">
      <label class="col-sm-2 col-form-label"></label>
      <div class="col-sm-5">
        <input type="checkbox" v-model="fill" @change="setFill()"> Llenado en almacén
      </div>
    </b-row> -->

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Comentarios</label>
      <div class="col-sm-5">
        <textarea v-model="service.comments" class="form-control" cols="30" rows="6"></textarea>
      </div>
    </b-row>

    <hr>
    <h5>Contenedores</h5>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Cantidad</label>
      <div class="col-sm-5">
        <input type="number" class="form-control" v-model="rq.quantity"/>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Tipo de carga</label>
      <div class="col-sm-5">
        <select v-model="rq.charge_type_id" required class="form-control" v-on:change="setChargeType()">
          <option v-for="(charge_type,k) in charge_types" :key="k" :value="charge_type.id">{{charge_type.name}}</option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group" v-if="charge_type && charge_type.name !== constants.SUELTA">
      <label class="col-sm-2 col-form-label">Tipo de contenedor</label>
      <div class="col-sm-5">
        <select v-model="rq.container_size_id" required class="form-control">
          <option
            v-for="(container_size,k) in container_sizes"
            :key="k"
            :value="container_size.id"
          >{{container_size.name}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group"
           v-if="(company != null || company === {}) &&
           (service_type.code === constants.IMPORTACION || (service_type.code === constants.EXPORTACION && !fill))">
      <label class="col-sm-2 col-form-label">
        Dirección de {{service_type.code === constants.IMPORTACION ? 'entrega' : 'llenado'}}
      </label>
      <div class="col-sm-5">
        <select
          v-model="rq.address_id"
          required
          class="form-control"
        >
          <option
            v-for="(address,k) in addresses.filter(ad => !ad.storage)"
            :key="k"
            :value="address.id"
          >{{address.alias}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Terminal de retiro</label>
      <div class="col-sm-5">
        <select
          v-model="rq.deposit_pick_id"
          class="form-control"
        >
          <option
            v-for="(depot,k) in deposits"
            :key="k"
            :value="depot.id"
          >{{depot.name}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group" v-if="charge_type.name !== constants.SUELTA">
      <label class="col-sm-2 col-form-label">Terminal de {{`${service_type.code === constants.IMPORTACION ? 'devolución'
        : 'entrega Full' }`}}</label>
      <div class="col-sm-5">
        <select
          v-model="rq.deposit_id"
          class="form-control"
        >
          <option
            v-for="(depot,k) in deposits"
            :key="k"
            :value="depot.id"
          >{{depot.name}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group"
           v-if="service_type.code === constants.IMPORTACION && charge_type.name !== constants.SUELTA">
      <label class="col-sm-2 col-form-label">Fecha sobre estadía</label>
      <div class="col-sm-5">
        <date-picker
          v-model="rq.container_expiration"
          lang="es"
          type="date"
          format="DD/MM/YYYY"
        ></date-picker>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Fecha entrega</label>
      <div class="col-sm-5">
        <date-picker
          v-model="rq.date"
          required
          lang="es"
          type="datetime"
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
        ></date-picker>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label"></label>
      <div class="col-sm-5">
        <input type="checkbox" v-model="rq.guard"> Resguardo
      </div>
    </b-row>

    <b-row class="form-group" v-if="rq.guard">
      <label class="col-sm-2 col-form-label">Tipo de custodia</label>
      <div class="col-sm-5">
        <select
          v-model="rq.custody_id"
          class="form-control"
        >
          <option
            v-for="(custody,k) in custodies"
            :key="k"
            :value="custody.id"
          >{{custody.name}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group">
      <b-col cols="12">
        <a
          href="javascript:void(0);"
          @click="addContainers()"
          class="btn btn-primary"
        >Agregar contenedores</a>
      </b-col>
    </b-row>

    <b-row class="form-group">
      <b-col cols="12">
        <div class="table-responsive">
          <table v-if="requeriments.length" class="table table-bordered table-hover table-striped">
            <thead>
            <tr>
              <th>Numero de contenedor</th>
              <th>Tamaño</th>
              <th>Carga</th>
              <th v-if="!fill">Dirección</th>
              <th>Terminal de retiro</th>
              <th>Terminal de {{`${service_type.code === constants.IMPORTACION ? 'devolución' : 'entrega Full' }`}}</th>
              <th v-if="fill">Horario de llenado</th>
              <th>Horario de entrega</th>
              <th v-if="service_type.code === constants.IMPORTACION">Sobre estadía</th>
              <th>Resguardo</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(requeriment, k) in paginated('requeriments')" :key="k">
              <td>
                <input type="text" v-model="requeriment.container_number" class="form-control">
              </td>
              <td>{{requeriment.charge_type.name === constants.SUELTA ? '--' : requeriment.container_size.name}}</td>
              <td>{{requeriment.charge_type.name}}</td>
              <td v-if="!fill">{{requeriment.address.alias}}</td>
              <td>
                <select v-model="requeriment.deposit_pick_id" class="form-control">
                  <option v-for="(depot, k) in deposits" :key="k" :value="depot.id">
                    {{depot.name}}
                  </option>
                </select>
              </td>
              <td>
                <select v-model="requeriment.deposit_id" class="form-control">
                  <option v-for="(depot, k) in deposits" :key="k" :value="depot.id">
                    {{depot.name}}
                  </option>
                </select>
              </td>
              <td v-if="fill">
                <date-picker v-model="requeriment.date_fill" lang="es" type="datetime" format="DD/MM/YYYY HH:mm"
                             :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                             placeholder="Horario de llenado"></date-picker>
              </td>
              <td>
                <date-picker v-model="requeriment.date" lang="es" type="datetime" format="DD/MM/YYYY HH:mm"
                             :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                             placeholder="Fecha entrega"></date-picker>
              </td>
              <td v-if="service_type.code === constants.IMPORTACION">
                <date-picker v-if="requeriment.charge_type.name !== constants.SUELTA"
                             v-model="requeriment.container_expiration" lang="es" type="date" format="DD/MM/YYYY"
                             placeholder="Fecha de sobre estadía"></date-picker>
                {{requeriment.charge_type.name === constants.SUELTA ? '--':''}}
              </td>
              <td>{{requeriment.guard ? custodies.find(c => c.id === requeriment.custody_id).name : 'No'}}</td>
              <td>
                <a href="javascript:void(0)">
                  <span class="fa fa-trash fa-lg" @click="removeContainer(requeriment, k)"></span>
                </a>&nbsp;
                <a href="javascript:void(0)" v-if="requeriment.id">
                  <span class="fa fa-edit fa-lg" @click="editContainer(requeriment, k)"></span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>

          <paginate name="requeriments" :list="requeriments" class="paginate-list" :per="10"></paginate>
          <paginate-links
            v-if="requeriments.length"
            for="requeriments"
            :limit="5"
            :show-step-links="true"
            :step-links="{next: '>>',prev: '<<'}"
            :classes="{'ul': 'pagination','li': 'page-item','a': 'page-link'}"
          ></paginate-links>
        </div>
        <div class="alert alert-info" v-if="!requeriments.length">
          No se han registrado contenedores. Debes ingresar al menos 1 contenedor
        </div>
      </b-col>
    </b-row>
    <div slot="footer" v-if="this.service.id && this.service.status.code === constants.DRAFT || !this.service.id">
      <b-button type="button" variant="primary" @click="setDraft()">Guardar borrador</b-button>&nbsp;
      <b-button type="button" variant="primary" @click="setPending()">Enviar</b-button>
    </div>
    <div slot="footer" v-if="this.service.id && this.service.status.code !== constants.DRAFT">
      <b-button type="button" variant="primary" @click="updateService()">Actualizar</b-button>
    </div>
  </b-form>
</template>

<script>
  import constants from "@/constants";
  import api from "@/helpers/api";
  import moment from "moment";
  import {mapGetters} from "vuex";

  const url = process.env.VUE_APP_SOCKET;
  export default {
    props: ["service_id"],
    data() {
      return {
        constants: {},
        service: {
          service_type_id: ""
        },
        rqs: [],
        paginate: ["requeriments"],
        rq: {
          container_size_id: null,
          charge_type_id: null,
          custody_id: null,
          deposit_id: null,
          deposit_pick_id: null,
          address_id: null
        },
        fill: false,
        address_dv: "",
        address_company: "",
        service_types: [],
        service_type: {},
        statuses: [],
        shipping_line: {},
        shipping_lines: [],
        deposit: {},
        deposits: [],
        container_size: {},
        container_sizes: [],
        charge_type: {},
        charge_types: [],
        companies: [],
        addresses: [],
        custodies: [],

        doc_bl_aux: "",
        doc_memo_aux: "",
        doc_booking_aux: "",
        doc_referral_guide_aux: "",
        doc_dam_aux: "",

        company: {},
        disableClient: false
      };
    },
    computed: {
      requeriments() {
        return this.rqs;
      },
      ...mapGetters({
        user: "user/user"
      })
    },
    watch: {
      company: function () {
        if (!this.company || this.company === {}) {
          this.addresses = []
          this.rq.address_id = null
        }
      }
    },
    mounted() {
      if (this.user.role.code === constants.EJECUTIVO_CUENTA) {
        this.constants = constants;

        if (this.service_id) {
          this.disableClient = true;
          api.get(`/service/${this.service_id}`).then(response => {
            this.service = response.service;
            this.rqs = response.requeriments;
            this.fill = this.rqs.some(rq => rq.fill)
            this.shipping_line = response.service.shipping_line;
            this.service_type = response.service.service_type;
            api.get('/company/' + this.service.company_id).then(response => {
              this.company = response.company
            })
          });

        }

        api.get("/companies").then(response => {
          this.companies = response.companies;
        });

        api.get("/shipping_lines").then(response => {
          this.shipping_lines = response.shipping_lines;
        });

        api.get("/deposits").then(response => {
          this.deposits = response.deposits;
        });

        api.get("/custodies").then(response => {
          this.custodies = response.custodies;
        });

        api.get("/container_sizes").then(response => {
          this.container_sizes = response.container_sizes;
        });

        api.get("/charge_types").then(response => {
          this.charge_types = response.charge_types.filter(ct => ct.inland);
        });

        api.get("/service_types").then(response => {
          this.service_types = response.service_types.filter(
            s => [constants.IMPORTACION, constants.EXPORTACION].indexOf(s.code) > -1
          );

          if (!this.service_id) {
            this.service.service_type_id = this.service_types.find(
              sv => sv.code === constants.IMPORTACION
            ).id;
            this.selectServiceType();
          }
        });

        api.get("/statuses").then(response => {
          this.statuses = response.status;
        });

      } else {
        this.constants = constants;
        if (this.service_id) {
          api.get(`/service/${this.service_id}`).then(response => {
            this.service = response.service;
            this.rqs = response.requeriments;

            this.fill = this.rqs.some(rq => rq.fill)

            this.shipping_line = response.service.shipping_line;
            // this.container_size = response.service.container_size
            // this.charge_type = response.requeriment.charge_type
            this.service_type = response.service.service_type;
          });
        }

        if (this.user.company_id) {
          api.get(`/company/${this.user.company_id}`).then(response => {
            this.addresses = response.company.addresses;
          });
        }

        api.get("/shipping_lines").then(response => {
          this.shipping_lines = response.shipping_lines;
        });

        api.get("/deposits").then(response => {
          this.deposits = response.deposits;
        });

        api.get("/custodies").then(response => {
          this.custodies = response.custodies;
        });

        api.get("/container_sizes").then(response => {
          this.container_sizes = response.container_sizes;
        });

        api.get("/charge_types").then(response => {
          this.charge_types = response.charge_types.filter(ct => ct.inland);
        });

        api.get("/service_types").then(response => {
          this.service_types = response.service_types.filter(
            s => [constants.IMPORTACION, constants.EXPORTACION].indexOf(s.code) > -1
          );

          if (!this.service_id) {
            this.service.service_type_id = this.service_types.find(
              sv => sv.code === constants.IMPORTACION
            ).id;
            this.selectServiceType();
          }
        });

        api.get("/statuses").then(response => {
          this.statuses = response.status;
        });
      }

    },
    methods: {
      setFill() {
        if (this.fill) {
          //this.rq.address_id = this.addresses.find(ad => ad.storage).id;

        }
      },
      setChargeType() {
        this.charge_type = this.charge_types.find(ct => ct.id === this.rq.charge_type_id)
        if (this.charge_type && this.charge_type.name === constants.SUELTA) {
          this.shipping_line = {}
          this.service.shipping_line_id = null
          this.rq.container_size_id = null
        }
      },
      selectServiceType() {
        this.service_type = this.service_types.find(
          s => s.id === this.service.service_type_id
        );
        if (this.service_type.code === constants.IMPORTACION) {
          this.fill = false;
        }
      },
      setShippingLine(obj) {
        this.shipping_line = obj ? obj : {};
        this.service.shipping_line_id = obj ? obj.id : null;
        // this.rq.deposit_id = obj ? obj.deposit_id :  ''
        // this.rq.deposit_pick_id = obj ? obj.deposit_id :  ''
      },
      setDeposit(obj) {
        this.service.deposit_id = obj ? obj.id : null;
      },
      handleBookingUpload() {
        this.doc_booking_aux = this.$refs.booking.files[0];
        //this.service.doc_booking = this.$refs.booking.files[0];
      },
      handleBlUpload() {
        this.doc_bl_aux = this.$refs.bl.files[0];
        //this.service.doc_bl = this.$refs.bl.files[0];
      },
      handleMemoUpload() {
        this.doc_memo_aux = this.$refs.memo.files[0];
        //this.service.doc_memo = this.$refs.memo.files[0];
      },
      handleReferralGuideUpload() {
        this.doc_referral_guide_aux = this.$refs.referral_guide.files[0];
        //this.service.doc_referral_guide = this.$refs.referral_guide.files[0];
      },
      handleDamUpload() {
        this.doc_dam_aux = this.$refs.dam.files[0];
        //this.service.doc_dam = this.$refs.dam.files[0];
      },
      addContainers(e) {
        if ((!this.rq.container_size_id || !this.rq.charge_type_id) && this.charge_type.name !== constants.SUELTA) {
          this.$toastr.warning('Debes indicar tamaño y tipo de carga', 'Contenedor', {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return
        }

        if (!this.rq.address_id && !this.fill) {
          this.$toastr.warning(
            "Debes indicar dirección de planta",
            "Contenedor",
            {positionClass: "toast-top-center", closeButton: true}
          );
          return;
        }

        if (!this.rq.quantity || this.rq.quantity <= 0) {
          this.$toastr.warning(
            "Debes indicar cantidad de contenedores",
            "Contenedor",
            {positionClass: "toast-top-center", closeButton: true}
          );
          return;
        }

        if (!this.rq.date) {
          this.$toastr.warning("Debes indicar fecha de entrega", "Contenedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return;
        }

        if (this.rq.guard && !this.rq.custody_id) {
          this.$toastr.warning("Si necesitas resguardo debes indicar el tipo de custodia.", "Contenedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return;
        }

        if (!this.rq.deposit_pick_id) {
          this.$toastr.warning("Debes indicar depósito de retiro", "Contenedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return;
        }

        if (this.service_type.code === constants.EXPORTACION && !this.rq.deposit_id && this.charge_type.name !== constants.SUELTA) {
          this.$toastr.warning("Debes indicar depósito de entrega", "Contenedor", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return;
        }

        for (let i = 0; i < this.rq.quantity; i++) {

          // this.deposit = this.deposits.find(d => d.id === this.shipping_line.deposit_id)

          let data = {
            _id: Date.now() + Math.random(),
            container_size_id: this.rq.container_size_id,
            container_size: this.container_sizes.find(
              cs => cs.id === this.rq.container_size_id
            ),
            charge_type_id: this.rq.charge_type_id,
            deposit_id: this.rq.deposit_id,
            deposit_pick_id: this.rq.deposit_pick_id,
            charge_type: this.charge_types.find(
              ct => ct.id === this.rq.charge_type_id
            ),
            address_id: this.rq.address_id,
            address: this.addresses.find(ad => ad.id === this.rq.address_id),
            guard: this.rq.guard,
            custody_id: this.rq.custody_id,
            fill: this.fill,
            date_fill: this.rq.date_fill ? moment(this.rq.date_fill).format('YYYY-MM-DD HH:mm:ss') : null,
            // deposit_id: this.shipping_line.id ? this.shipping_line.deposit_id : null,
            container_expiration: this.rq.container_expiration
              ? moment(this.rq.container_expiration).format("YYYY-MM-DD HH:mm:ss")
              : null,
            date: this.rq.date
              ? moment(this.rq.date).format("YYYY-MM-DD HH:mm:ss")
              : null
          };
          this.rqs.push(data);
        }
        this.$toastr.info("Contenedores agregados", "Contenedores", {
          positionClass: "toast-top-center",
          closeButton: true
        });
        this.rq = {container_size_id: "", charge_type_id: "", address_id: "", deposit_id: '', deposit_pick_id: ''};
      },
      removeContainer(rq, index) {
        // console.log(rq)
        // console.log(index)
        // console.log(this.currentPage)
        // return
        if (this.rqs.length <= 1 && this.service_id) {
          // this.$toastr.error('Debes registrar al menos 1 contenedor', 'Contenedores', { positionClass: "toast-top-center", closeButton: true })

          if (confirm('Si eliminas este último contenedor se eliminará el servicio completo, ¿Seguro deseas continuar?')) {
            api.delete(`/service/${this.service_id}`).then(response => {
              this.$toastr.success('Servicio eliminado', 'Servicio', {
                positionClass: "toast-top-center",
                closeButton: true
              })
            })
            this.$router.push('/services/pending')
          }
        } else {
          if (rq.id) {
            api.delete(`/requeriment/${rq.id}`).then(response => {
              this.rqs.splice(index, 1);
              this.$toastr.success(
                "Requerimiento eliminado exitosamente.",
                "Requerimiento",
                {positionClass: "toast-top-center", closeButton: true}
              );
            });
          } else {
            index = this.rqs.findIndex(req => req._id === rq._id);
            this.rqs.splice(index, 1);
            this.$toastr.success(
              "Requerimiento eliminado exitosamente.",
              "Requerimiento",
              {positionClass: "toast-top-center", closeButton: true}
            );
          }
        }
      },
      editContainer(requeriment, k) {
        this.$router.push(`/requeriment/edit/${requeriment.id}`);
      },
      setDraft() {
        this.service.status_id = this.statuses.find(
          st => st.code === constants.DRAFT
        ).id;

        this.send();
      },
      setPending() {
        let service_type = this.service_types.find(st => st.id === this.service.service_type_id)
        let result = true
        if (service_type.code === constants.EXPORTACION) {
          // Si es EXPO revisamos fechas de todos los requerimientos
          // Si es IMPO siempre marcado como pendiente
          let tomorrow = moment().add(1, 'day').format('YYYY-MM-DD')
          let cutoff = moment().format('YYYY-MM-DD 15:00:00')
          result = this.requeriments.some(rq => {
            let date = moment(rq.date).format('YYYY-MM-DD')
            let current = moment().format('YYYY-MM-DD HH:mm:ss')
            return moment(date).isSame(tomorrow) && moment(current).isAfter(cutoff)
          })
        }
        this.service.status_id = this.statuses.find(
          st => st.code == (result ? constants.PENDIENTE : constants.APROBADO)
        ).id;

        if (
          confirm(
            "Una vez enviado sólo podrá realizar modificaciones antes del horario de corte, ¿Seguro desea enviarlo?"
          )
        ) {
          //Validar antes de enviar
          if (!this.service.service_type_id) {
            this.$toastr.warning(
              "Debes indicar tipo de servicio",
              "Requerimiento",
              {positionClass: "toast-top-center", closeButton: true}
            );
            return;
          }

          this.updateService();
        }
      },
      updateService() {


        if (!this.service.shipping_line_id && this.charge_type.name !== constants.SUELTA) {
          this.$toastr.warning('Debes indicar línea naviera', 'Requerimiento', {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return
        }

        let validate_current = this.requeriments.some(requeriment => {
          return moment(requeriment.date).format('YYYY-MM-DD HH:mm:ss') <= moment().format('YYYY-MM-DD HH:mm:ss')
        })

        if (validate_current) {
          this.$toastr.error('Al menos uno de tus contenedores posee una fecha de entrega previa al horario actual.', 'Requerimiento', {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return
        }

        // Valido sólo fecha-hora de corte cuando es una actualización. cuando se crea no se valida
        let cutoff = moment().format('YYYY-MM-DD 17:00:00')
        if (this.service.id) {
          let tomorrow_start = moment().format('YYYY-MM-DD 00:00:00')
          let tomorrow_end = moment().add(1, 'days').format('YYYY-MM-DD 23:59:59')
          let current_date = moment().format('YYYY-MM-DD HH:mm:ss')
          let validate_cutoff = this.requeriments.some(requeriment => {
            let req_date = moment(requeriment.date).format('YYYY-MM-DD HH:mm:ss')
            return req_date >= tomorrow_start && req_date <= tomorrow_end && current_date >= cutoff
          })

          if (validate_cutoff) {
            this.$toastr.error('No es posible actualizar este servicio después del horario de corte: 17:00hrs.', 'Requerimiento', {
              positionClass: "toast-top-center",
              closeButton: true
            });
            return
          }
        }

        this.send();
      },
      send() {
        let formData = new FormData();



        for (let key in this.service) {
          if (this.service[key] && this.service[key].size > 0) {
            formData.append(key, this.service[key]);
          } else {
            if (this.service[key] && key === "date") {
              formData.append(
                key,
                moment(this.service[key]).format("YYYY-MM-DD HH:mm:ss")
              );
            } else if (this.service[key]) {
              if (
                typeof this.service[key] === "string" ||
                this.service[key] instanceof String
              ) {
                formData.append(key, this.service[key].toUpperCase());
              } else {
                formData.append(key, this.service[key]);
              }
            }
          }
        }

        let total_invalid_container = 0
        this.requeriments.forEach((rq, key) => {
          if (rq.date) {
            this.requeriments[key].date = moment(rq.date).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }

          if (rq.date_fill) {
            this.requeriments[key].date_fill = moment(rq.date_fill).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }

          if (this.requeriments[key].container_number) {
            this.requeriments[key].container_number = this.requeriments[
              key
              ].container_number.replace(/\s/g, '').toUpperCase();

            if (!this.requeriments[key].container_number.match(/^[A-Z]{4}\d{7}$/s)) {
              console.log("Invalido: " + this.requeriments[key].container_number)
              total_invalid_container++
            }
          }

          // this.deposit = this.deposits.find(d => d.id === this.shipping_line.deposit_id)
          // this.requeriments[key].deposit_id = this.deposit ? this.deposit.id : null

          if (rq.container_expiration) {
            this.requeriments[key].container_expiration = moment(
              rq.container_expiration
            ).format("YYYY-MM-DD 23:59:59");
          }
        })

        if (this.requeriments.length <= 0) {
          this.$toastr.error('Debes ingresar al menos 1 contenedor', "Contenedores", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        } else if (total_invalid_container > 0) {
          this.$toastr.error('Uno o más contenedores no han sido registrados con el formato válido (4 letras seguido de 7 dígitos). Total contendores incorrectos: ' + total_invalid_container, "Contenedores", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        } else {

          formData.append('requeriments', JSON.stringify(this.requeriments))
          if (this.service_id) {
            formData.delete('service_type')

            if (this.deposit) {
              formData.delete('deposit')
            }

            if (this.shipping_line) {
              formData.delete('shipping_line')
            }

            formData.delete('company')
            formData.delete('status')
            formData.delete('truck')
            formData.delete('driver')
            //formData.delete('container_size')
            //formData.delete('charge_type')
            api.put(`/service/${this.service_id}`, formData).then(response => {
              console.log(response);
              if (response.success) {
                this.$toastr.success(`Servicio actualizado`, "Servicio", {
                  positionClass: "toast-top-center",
                  closeButton: true
                });
                if (response.service.status.code === constants.DRAFT) {
                  this.$router.push("/services/draft");
                } else {
                  this.$router.push("/services/pending");
                }
              }
            });
          } else {
            if (this.user.role.code === constants.EJECUTIVO_CUENTA) {
              console.log('this.company.id')
              console.log(this.company.id)
              formData.append('company_id', this.company.id)
            }
            api.post("/service", formData).then(response => {
              if (response.success) {
                //alert('Requerimiento creado exitosamente')
                this.$toastr.success(`Servicio creado exitosamente`, "Servicio", {
                  positionClass: "toast-top-center",
                  closeButton: true
                });
                this.$socket.emit("newServiceServer", response.service);
                if (response.service.status.code === constants.DRAFT) {
                  this.$router.push("/services/draft");
                } else {
                  this.$router.push("/services/pending");
                }

                //this.$router.push('/requeriments/pending')
              }
            });
          }
        }
      },
      setCompany(obj) {
        this.company = obj ? obj : {};
        console.log('this.company.id')
        console.log(this.company)
        if (this.company.id) {
          api.get(`/company/${this.company.id}`).then(response => {
            this.addresses = response.company.addresses;
          });
          console.log("111111")
        }

        console.log("222222")
      }
    }
  };
</script>

<style scoped>
  input {
    text-transform: uppercase;
  }
</style>

